const LAppDefine = {
    VIEW_MAX_SCALE: 1.5,
    VIEW_MIN_SCALE: 1,
    VIEW_LOGICAL_LEFT: -1,
    VIEW_LOGICAL_RIGHT: 1,
    VIEW_LOGICAL_MAX_LEFT: -2,
    VIEW_LOGICAL_MAX_RIGHT: 2,
    VIEW_LOGICAL_MAX_BOTTOM: -2,
    VIEW_LOGICAL_MAX_TOP: 2,
    PRIORITY_NONE: 0,
    PRIORITY_IDLE: 1,
    PRIORITY_NORMAL: 2,
    PRIORITY_FORCE: 3,
    MOTION_GROUP_IDLE: 'idle',
    MOTION_GROUP_TAP_BODY: 'tap_body',
    MOTION_GROUP_FLICK_HEAD: 'flick_head',
    MOTION_GROUP_PINCH_IN: 'pinch_in',
    MOTION_GROUP_PINCH_OUT: 'pinch_out',
    MOTION_GROUP_SHAKE: 'shake',
    HIT_AREA_HEAD: 'head',
    HIT_AREA_BODY: 'body',
};
export default LAppDefine;
